import { ProprietaryIconsModel } from 'app/shared/component/proprietary-icons/proprietary-icons.model';

export const proprietaryIcons: ProprietaryIconsModel[] = [
	{ label: 'account-inactive' },
	{ label: 'add-farm' },
	{ label: 'adjust-options-small' },
	{ label: 'admin-users' },
	{ label: 'ai-stars-small' },
	{ label: 'app-dg' },
	{ label: 'app-sf' },
	{ label: 'batch-history' },
	{ label: 'calculator' },
	{ label: 'clock' },
	{ label: 'cow-active' },
	{ label: 'cow-unclicked' },
	{ label: 'cow' },
	{ label: 'custom-plan' },
	{ label: 'dg-icon' },
	{ label: 'draft' },
	{ label: 'farmer' },
	{ label: 'farms' },
	{ label: 'feed-mixer' },
	{ label: 'file-upload' },
	{ label: 'free' },
	{ label: 'global-products' },
	{ label: 'info-square' },
	{ label: 'leaf' },
	{ label: 'limit-reached' },
	{ label: 'load-wave' },
	{ label: 'manual-release' },
	{ label: 'manual-releases-chip' },
	{ label: 'milk-production' },
	{ label: 'no-manual-releases' },
	{ label: 'no-releases-to-fm' },
	{ label: 'no-results' },
	{ label: 'no-studentgroups' },
	{ label: 'not_set' },
	{ label: 'nutrition' },
	{ label: 'pdf' },
	{ label: 'premium-crown' },
	{ label: 'production-cow' },
	{ label: 'production' },
	{ label: 'products-bag' },
	{ label: 'products-in-box' },
	{ label: 'ration-released' },
	{ label: 'ration-scales' },
	{ label: 'released-manual' },
	{ label: 'save-outline' },
	{ label: 'star-outline' },
	{ label: 'star' },
	{ label: 'stock-dashboard' },
	{ label: 'stock-delivery-icon' },
	{ label: 'stock' },
	{ label: 'students-groups' },
	{ label: 'sync-bg' },
	{ label: 'user' },
	{ label: 'users' },
	{ label: 'waggon-50' },
	{ label: 'waggon-DG' },
];
